/* Apnaugao header inline search (moved from snippet, Oct 2026). Config: window.csSearchCfg */
(function () {
  if (window.__csPlaceholderInit) return;
  window.__csPlaceholderInit = true;

  const enabled = !!(window.csSearchCfg||{}).anim;
  if (!enabled) return;

  const phrases = ((window.csSearchCfg||{}).phrases||[]);

  const SPEED_MAP = {
    slow:   { type: 140, del: 80 },
    normal: { type: 90,  del: 50 },
    fast:   { type: 60,  del: 30 }
  };
  const speed = SPEED_MAP[(window.csSearchCfg||{}).speed] || SPEED_MAP.normal;

  function start() {
    document.querySelectorAll('[data-placeholder-animate]').forEach(input => {
      if (input.dataset.placeholderInit === "1") return;
      input.dataset.placeholderInit = "1";

      let phraseIdx = 0, charIdx = 0, isDeleting = false, timer = null;

      function tick() {
        const current = phrases[phraseIdx] || "";
        if (!isDeleting) {
          input.placeholder = current.slice(0, charIdx + 1);
          charIdx++;
          if (charIdx === current.length) {
            isDeleting = true;
            timer = setTimeout(tick, 1200);
            return;
          }
        } else {
          input.placeholder = current.slice(0, charIdx - 1);
          charIdx--;
          if (charIdx === 0) {
            isDeleting = false;
            phraseIdx = (phraseIdx + 1) % phrases.length;
          }
        }
        timer = setTimeout(tick, isDeleting ? speed.del : speed.type);
      }

      input.addEventListener('focus', () => {
        input.placeholder = "";
        if (timer) { clearTimeout(timer); timer = null; }
      });
      input.addEventListener('blur', () => {
        if (input.value) return;
        charIdx = 0;
        isDeleting = false;
        if (!timer) tick();
      });

      tick();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

(function () {
  if (window.__csOpenCloseInit) return;
  window.__csOpenCloseInit = true;

  const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

  // Build the "Recommended for you" cards the first time a dropdown opens
  function hydrateRecommended(dropdown) {
    const tpl = dropdown.querySelector('[data-cs-rec-template]');
    const wrapper = dropdown.querySelector('[data-cs-rec-wrapper]');
    if (!tpl || !wrapper || wrapper.dataset.hydrated === '1') return;
    wrapper.dataset.hydrated = '1';
    wrapper.appendChild(tpl.content.cloneNode(true));
    if (typeof window.__csInitRecSlider === 'function') {
      window.__csInitRecSlider(wrapper.closest('.cs-recommended-slider'));
    }
  }

  function initSearch(dropdown) {
    if (dropdown.dataset.csBound === '1') return;
    dropdown.dataset.csBound = '1';

    const root         = dropdown.parentElement;
    const input        = root ? root.querySelector('[data-inline-search-input]') : null;
    if (!input) return;

    const closeBtn     = dropdown.querySelector('[data-cs-close]');
    const overlayInput = dropdown.querySelector('[data-cs-overlay-input]');
    const overlayForm  = dropdown.querySelector('[data-cs-overlay-form]');

    function open() {
      hydrateRecommended(dropdown);
      dropdown.removeAttribute('hidden');
      if (isMobile()) {
        document.body.classList.add('cs-search-open');
        if (overlayInput) {
          overlayInput.value = input.value;
          setTimeout(() => overlayInput.focus(), 50);
        }
      }
    }

    function close() {
      dropdown.setAttribute('hidden', '');
      document.body.classList.remove('cs-search-open');
      input.blur();
      if (overlayInput) overlayInput.blur();
    }

    if (overlayInput) {
      overlayInput.addEventListener('input', () => {
        input.value = overlayInput.value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    if (overlayForm) {
      overlayForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const realForm = input.closest('form');
        if (realForm) realForm.submit();
      });
    }

    input.addEventListener('focus', open);
    input.addEventListener('click', open);

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        close();
      });
    }

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !dropdown.hasAttribute('hidden')) close(); });

    document.addEventListener('click', (e) => {
      if (isMobile()) return;
      if (dropdown.hasAttribute('hidden')) return;
      if (input.contains(e.target)) return;
      if (dropdown.contains(e.target)) return;
      close();
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-cs-dropdown]').forEach(initSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();

(function () {
  if (window.__csPredictiveInit) return;
  window.__csPredictiveInit = true;

  function wire(dropdown) {
    if (dropdown.dataset.csPredictive === '1') return;
    dropdown.dataset.csPredictive = '1';

    const root              = dropdown.parentElement;
    const input             = root ? root.querySelector('[data-inline-search-input]') : null;
    const emptyBlocks       = dropdown.querySelectorAll('[data-empty-block]');
    const predictiveBlock   = dropdown.querySelector('[data-predictive-block]');
    const collectionsBlock  = dropdown.querySelector('[data-predictive-collections]');
    const collectionList    = dropdown.querySelector('[data-collection-list]');
    const suggestionsBlock  = dropdown.querySelector('[data-predictive-suggestions]');
    const suggestionList    = dropdown.querySelector('[data-suggestion-list]');
    const resultsBlock      = dropdown.querySelector('[data-predictive-results]');
    const resultsGrid       = dropdown.querySelector('[data-predictive-products]');
    const articlesBlock     = dropdown.querySelector('[data-predictive-articles]');
    const articleList       = dropdown.querySelector('[data-article-list]');
    const viewAll           = dropdown.querySelector('[data-view-all]');
    const viewAllLink       = dropdown.querySelector('[data-view-all-link]');
    const overlayInput      = dropdown.querySelector('[data-cs-overlay-input]');
    const clearBtn          = dropdown.querySelector('[data-cs-overlay-clear]');
    if (!input || !predictiveBlock) return;

    let controller;

    function toggleClearBtn(value) {
      if (!clearBtn) return;
      if (value && value.length > 0) clearBtn.removeAttribute('hidden');
      else clearBtn.setAttribute('hidden', '');
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        input.value = '';
        if (overlayInput) overlayInput.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        if (overlayInput) overlayInput.focus();
      });
    }

    let debounceTimer = null;
    const DEBOUNCE_MS = 200;

    function setEmpty() {
      emptyBlocks.forEach(b => b.hidden = false);
      predictiveBlock.hidden = true;
      if (collectionsBlock) collectionsBlock.hidden = true;
      if (suggestionsBlock) suggestionsBlock.hidden = true;
      if (resultsBlock) resultsBlock.hidden = true;
      if (articlesBlock) articlesBlock.hidden = true;
      if (collectionList) collectionList.innerHTML = '';
      if (suggestionList) suggestionList.innerHTML = '';
      if (resultsGrid) resultsGrid.innerHTML = '';
      if (articleList) articleList.innerHTML = '';
      if (viewAll) viewAll.removeAttribute('data-visible');
    }

    input.addEventListener('input', function () {
      const query = this.value.trim();
      toggleClearBtn(query);

      if (!query) {
        if (controller) controller.abort();
        if (debounceTimer) clearTimeout(debounceTimer);
        setEmpty();
        return;
      }

      emptyBlocks.forEach(b => b.hidden = true);
      predictiveBlock.hidden = false;

      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => doFetch(query), DEBOUNCE_MS);
    });

    async function doFetch(query) {
      if (controller) controller.abort();
      controller = new AbortController();

      const url = '/search/suggest.json'
        + '?q=' + encodeURIComponent(query)
        + '&resources[type]=product,query,article,collection'
        + '&resources[limit]=10'
        + '&resources[options][unavailable_products]=last'
        + '&resources[options][fields]=title,vendor,product_type,variants.title';

      try {
        const res = await fetch(url, { signal: controller.signal });
        const data = await res.json();
        const r = (data && data.resources && data.resources.results) || {};
        const products    = r.products    || [];
        const queries     = r.queries     || [];
        const articles    = r.articles    || [];
        const collections = r.collections || [];

        if (collections.length && collectionList && collectionsBlock) {
          collectionList.innerHTML = collections.slice(0, 6).map(c => `
            <li class="cs-collection-item">
              <a href="${c.url}" class="cs-collection-link">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <rect x="3" y="3" width="7" height="7" rx="1" stroke="#888" stroke-width="2"/>
                  <rect x="14" y="3" width="7" height="7" rx="1" stroke="#888" stroke-width="2"/>
                  <rect x="3" y="14" width="7" height="7" rx="1" stroke="#888" stroke-width="2"/>
                  <rect x="14" y="14" width="7" height="7" rx="1" stroke="#888" stroke-width="2"/>
                </svg>
                <span>${c.title}</span>
              </a>
            </li>
          `).join('');
          collectionsBlock.hidden = false;
        } else if (collectionsBlock) {
          collectionsBlock.hidden = true;
        }

        if (queries.length && suggestionList && suggestionsBlock) {
          suggestionList.innerHTML = queries.slice(0, 8).map(q => `
            <li class="cs-suggestion-item">
              <a href="${q.url}" class="cs-suggestion-link">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <circle cx="11" cy="11" r="7" stroke="#888" stroke-width="2"/>
                  <line x1="30" y1="30" x2="16.5" y2="16.5" stroke="#888" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span>${q.text}</span>
              </a>
            </li>
          `).join('');
          suggestionsBlock.hidden = false;
        } else if (suggestionsBlock) {
          suggestionsBlock.hidden = true;
        }

        if (products.length && resultsGrid && resultsBlock) {
          resultsGrid.innerHTML = products.slice(0, 6).map(p => `
            <a href="${p.url}" class="cs-product-card">
              <div class="cs-product-image">
                <img src="${p.image}" alt="${p.title}" loading="lazy">
              </div>
              <div class="cs-product-title">${p.title}</div>
              <div class="cs-product-price">${p.price}</div>
            </a>
          `).join('');
          resultsBlock.hidden = false;
        } else if (resultsBlock) {
          resultsBlock.hidden = true;
        }

        if (articles.length && articleList && articlesBlock) {
          articleList.innerHTML = articles.slice(0, 6).map(a => `
            <li class="cs-article-item">
              <a href="${a.url}" class="cs-article-link">
                <svg class="cs-article-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="14 2 14 8 20 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="cs-article-title">${a.title}</span>
              </a>
            </li>
          `).join('');
          articlesBlock.hidden = false;
        } else if (articlesBlock) {
          articlesBlock.hidden = true;
        }

        if (viewAll && viewAllLink) {
          if (products.length || queries.length || articles.length || collections.length) {
            viewAllLink.setAttribute('href', '/search?q=' + encodeURIComponent(query));
            viewAllLink.textContent = 'View all results for "' + query + '" →';
            viewAll.setAttribute('data-visible', '1');
          } else {
            viewAll.removeAttribute('data-visible');
          }
        }

        if (!queries.length && !products.length && !articles.length && !collections.length && resultsBlock && resultsGrid) {
          resultsGrid.innerHTML = '<p class="cs-predictive-empty">No results found</p>';
          resultsBlock.hidden = false;
        }
      } catch (e) {
        if (e.name !== 'AbortError') {
          console.error('[cs-search] predictive fetch failed', e);
        }
      }
    }
  }

  function bootstrap() {
    document.querySelectorAll('[data-cs-dropdown]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();

(function () {
  if (window.__csInitRecSlider) return;

  function build(slider) {
    if (!slider || slider.dataset.init === '1') return;
    slider.dataset.init = '1';

    const parent  = slider.closest('.cs-search-block');
    const nextBtn = parent ? parent.querySelector('.cs-swiper-next') : null;
    const prevBtn = parent ? parent.querySelector('.cs-swiper-prev') : null;

    function toggleArrows(s) {
      if (!prevBtn || !nextBtn) return;
      prevBtn.style.display = s.isBeginning ? 'none' : 'flex';
      nextBtn.style.display = s.isEnd       ? 'none' : 'flex';
    }

    new Swiper(slider, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 14,
      loop: false,
      watchOverflow: true,
      allowTouchMove: false,
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
      on: {
        init:        function () { toggleArrows(this); },
        slideChange: function () { toggleArrows(this); },
        resize:      function () { toggleArrows(this); }
      }
    });
  }

  // Load Swiper only when it is actually needed (first open of the dropdown on desktop).
  var swiperQueue = null;
  function loadSwiper(cb) {
    if (typeof Swiper !== 'undefined') { cb(); return; }
    if (swiperQueue) { swiperQueue.push(cb); return; }
    swiperQueue = [cb];
    var s = document.createElement('script');
    s.src = (window.csSearchCfg||{}).swiper;
    s.async = true;
    s.onload = function () {
      var q = swiperQueue; swiperQueue = [];
      q.forEach(function (fn) { fn(); });
    };
    document.head.appendChild(s);
  }

  window.__csInitRecSlider = function (slider) {
    if (!slider) return;
    if (window.matchMedia('(max-width: 1023px)').matches) return; // mobile uses a CSS grid
    loadSwiper(function () { build(slider); });
  };
})();

(function () {
  if (window.__csScrollCloseInit) return;
  window.__csScrollCloseInit = true;

  const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

  let lastScrollY = window.scrollY;
  const THRESHOLD = 100;

  function onScroll() {
    if (isMobile()) return;

    const delta = Math.abs(window.scrollY - lastScrollY);
    if (delta < THRESHOLD) return;
    lastScrollY = window.scrollY;

    document.querySelectorAll('[data-cs-dropdown]').forEach(d => {
      if (!d.hasAttribute('hidden')) d.setAttribute('hidden', '');
    });
    document.querySelectorAll('[data-inline-search-input]').forEach(i => i.blur());
  }

  window.addEventListener('scroll', onScroll, { passive: true });
})();
